import { logger } from '@/utils/logger/logger';

export const NARRATION_PREFERENCE_STORAGE_KEY = 'rpa-recorder:capture-narration';

export function readCaptureNarrationPreference(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const raw = window.localStorage.getItem(NARRATION_PREFERENCE_STORAGE_KEY);
    if (raw === null) return false;
    return raw === 'true';
  } catch (error) {
    logger.warn({
      msg: '[rpa-recorder] Failed to read narration preference; defaulting to off',
      error: error instanceof Error ? error.message : String(error),
    });
    return false;
  }
}

export function writeCaptureNarrationPreference(enabled: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(
      NARRATION_PREFERENCE_STORAGE_KEY,
      enabled ? 'true' : 'false'
    );
  } catch (error) {
    // incognito / quota — preference won't persist, but don't fail silently
    logger.warn({
      msg: '[rpa-recorder] Failed to persist narration preference',
      error: error instanceof Error ? error.message : String(error),
    });
  }
}
